RCDPW.module('RCDPW.validator.rules.hiddenForm', {
    appName: 'required',
    maxRequestPerDay: {
        number: true,
        min: 1
    },
    maxSmsPerDay: {
        number: true,
        min: 1
    },
    maxFaxPerDay: {
        number: true,
        min: 1
    },
    developmentStartDate: {
        required: true,
        date: true,
        dateFromNow: true
    },
    productionDate: {
        required: {
            depends: function () {
                // Validate only when development start date is valid.
                return !$('#dpw-developmentStartDate').hasClass('error');
            }
        },
        date: true
    },
    proDateMinusDevDate: {
        positiveInt: {
            depends: function () {
                return !$('#dpw-developmentStartDate').hasClass('error');
            }
        }
    },
    userinput: {
        required: {
            depends: function () {
                return !!$('#want_to_resell:checked').prop('checked');
            }
        }
    },
    License_agreed: 'required'
});